export default __webpack_public_path__ + "static/media/home-finance-industries-img-05.75b2d3e5.jpg";